import {
  Exact,
  InputMaybe,
  VaCountQuery,
  VaFollowUpFilterInput,
} from '@api/generated/graphql';
import { QueryHookOptions, useLazyQuery } from '@apollo/client';
import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import { GET_VA_FOLLOW_UPS_COUNT_QUERY } from './data/count';
import { getVirtualAgentFollowUpsBadgeCountFilters } from '@pages/urgentfollowups/VirtualAgentFollowUpsPage/utils/filters';

export type VaCountExecuteQueryOptions = QueryHookOptions<
  VaCountQuery,
  Exact<{
    filter?: InputMaybe<VaFollowUpFilterInput>;
    take?: InputMaybe<number>;
  }>
>;

let executeQuery: (options?: VaCountExecuteQueryOptions) => void;

export function useVirtualAgentFollowUpsCountQuery() {
  const [execute, queryResult] = useLazyQuery(GET_VA_FOLLOW_UPS_COUNT_QUERY, {
    fetchPolicy: 'network-only',
  });
  executeQuery = execute;

  return {
    error: queryResult.error,
    previousCount: queryResult.previousData?.vaFollowUps?.totalCount,
    currentCount: queryResult.data?.vaFollowUps?.totalCount,
    execute: (options?: QueryHookOptions<VaCountQuery>) => {
      execute(options);
    },
  };
}

class VirtualAgentFollowUpsModule extends AppModule {
  override events = ['virtualAgentFollowUp.update'];

  override preload(): void {
    if (executeQuery === undefined) {
      this.app.logger.warn(
        'VirtualAgentFollowUpsModule: executeQuery is undefined, ensure useVirtualAgentFollowUpsCountQuery is called before this module is used.',
      );
    }
    this.app.events.on('virtualAgentFollowUp.update', () => {
      this.app.logger.info('trigger VA followups refresh');
      executeQuery?.({
        variables: {
          filter: getVirtualAgentFollowUpsBadgeCountFilters(),
          take: 1,
        },
      });
    });
  }
}

export default new VirtualAgentFollowUpsModule(
  appManager.events,
  appManager.logger('VirtualAgentFollowUpsCount'),
);
